module.exports = __webpack_public_path__ + "media/images/emblems/Borex-coat_of_arms-4df99a3e403592e167a0f80b8a747317.svg";